import { Injectable } from '@angular/core';
import { catchError,map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AlertHelper } from 'src/app/shared/components/helpers/alert.helpers';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, throwError } from 'rxjs';
import { RequestResponse } from 'src/app/shared/models/request-response.interface';

@Injectable({
  providedIn: 'root'
})
export class PerfilesService {

  constructor(private http:HttpClient,private router: Router,private alert:AlertHelper) { }
  //GetAll_perfiles
  traerPerfiles(){
    return this.http
    .get<RequestResponse >(`${environment.API}/rrhh/perfiles/`)
    .pipe(
      map((res:RequestResponse) =>{
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }
  //Create_Perfil
  crearPerfil(entity:any){                   
    return this.http
    .post<RequestResponse >(`${environment.API}/rrhh/perfiles/crear`,entity)
    .pipe(
      map((res:RequestResponse) =>{
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }

  private handlerError(err: any):Observable<never>{
    let errorMessage = "";
    if (err) {
      errorMessage = `Error: ${err.error.msg}`;
    }
    this.alert.error_small(err.error.msg);
    return throwError(errorMessage);
  }




}
